<script>
  import { post } from "../js/labit-connection";
  import { getAllProjects } from "../js/projects";

  import { onMount } from "svelte";

  onMount(async () => {
    /*const response = await post(
      `select project_id, role_id, R.role as contactRole, P.contact_id as contactId, startDate, endDate, C.company_id as companyId, esLabit
            from teams as T
            left join people as P on P.contact_id=T.contact_id
            left join companies as C on C.company_id=P.company_id
            left join roles as R on R.id=T.role_id`
    );*/
    /*const response = await post(
      `select project_id, role_id, P.contact_id as contactId, startDate, endDate, C.company_id as companyId, esLabit
            from project_contacts as T
            left join people as P on P.contact_id=T.contact_id
            left join companies as C on C.company_id=P.company_id`
    );

    const today = moment().format("YYYY-MM-DD");

    for (let i = 0; i < response.length; i++) {
      const r = response[i];
      let active = 1;
      let unactiveDate = "null";
      let role = "";
      let stakeholder = r.esLabit === "0";
      if (r.esLabit === "1") {
        //active = r.endDate >= today;
        active = true;
        unactiveDate = active ? "null" : `'${r.endDate}'`;
        //role = r.role_id === "1" ? "Project Manager" : "Regular Team";
        role = r.contactRole;
      }
      /*console.log(`insert into projectPeople (people, project, role, active, unactiveDate)
              values (${r.contactId}, ${r.project_id}, '${role}', ${
        active ? "1" : "0"
      }, ${unactiveDate})`);*/
    /*await post(
        `insert into projectPeople (people, project, role, start, end, active, unactiveDate, stakeholder)
              values (${r.contactId}, ${r.project_id}, '${role}', '${
          r.startDate
        }', '${r.endDate}', ${active ? "1" : "0"}, ${unactiveDate}, ${
          stakeholder ? "1" : "0"
        })`
      );
    }
    //
    /*const response = await post(
      `select distinct project_id, C.company_id as companyId, esLabit
            from teams as T
            left join people as P on P.contact_id=T.contact_id
            left join companies as C on C.company_id=P.company_id`
    );

    /*const response = await post(
      `select distinct project_id, C.company_id as companyId, esLabit
            from project_contacts as T
            left join people as P on P.contact_id=T.contact_id
            left join companies as C on C.company_id=P.company_id`
    );*/
    /*for (let i = 0; i < response.length; i++) {
      const r = response[i];
      if (r.esLabit !== "1") {
        console.log(
          `insert into projectCompany (company, project, role)
                values (${r.companyId}, ${r.project_id}, '')`
        );

        /*await post(
          `insert into projectCompany (company, project, role)
                values (${r.companyId}, ${r.project_id}, '')`
        );*/
    /*}
    }*/
    //
    /*const response = await post(
      `select project_id, active
        from projects`
    );
    for (let i = 0; i < response.length; i++) {
      const r = response[i];
      let resp = await post(
        `select Start
          from project_status
          where project_id=${r.project_id}
          order by Start asc`
      );
      if (resp.length === 0) {
        await post(
          `insert into statusHistory (start, end, status, project)
            values ('${moment().format("YYYY-MM-DD")}', null, ${
            r.active === "1" ? 1 : 4
          }, ${r.project_id})`
        );
      } else {
        let start = resp[0].Start;
        if (r.active === "1") {
          await post(
            `insert into statusHistory (start, end, status, project)
               values ('${start}', null, 1, ${r.project_id})`
          );
        } else {
          resp = await post(
            `select End
              from project_status
              where project_id=${r.project_id}
              order by End desc`
          );
          let end = resp[0].End;
          await post(
            `insert into statusHistory (start, end, status, project)
              values ('${start}', '${end}', 1, ${r.project_id})`
          );
          await post(
            `insert into statusHistory (start, end, status, project)
              values ('${end}', null, 4, ${r.project_id})`
          );
        }
      }
    }*/
    /*console.log("EMPIEZO");
    const response = await post(
      `select company_id, category_id
      from companies`
    );

    for (let i = 0; i < response.length; i++) {
      const c = response[i];
      await post(
        `insert into companyCategories (company, category)
        values (${c.company_id}, ${c.category_id})`
      );
    }
    console.log(response);*/
    /*let response = await post(
      `select project_id, serverUrl, trelloUrl, slackUrl, sharepointUrl, bim360Url, miroUrl
        from projects`
    );

    response.forEach((item) => {
      item.serverUrl = item.serverUrl.replace(/\\/g, "/");
      if (
        item.serverUrl !== "" &&
        !item.serverUrl.startsWith("file:") &&
        !item.serverUrl.startsWith("http")
      ) {
        item.serverUrl = "file:///" + item.serverUrl;
      }
    });

    for (let i = 0; i < response.length; i++) {
      const project = response[i];
      if (project.serverUrl !== "") {
        await post(
          `insert into externalUrls (url, type, project)
            values ('${project.serverUrl}', 'Server', '${project.project_id}')`
        );
      }
      if (project.trelloUrl !== "") {
        await post(
          `insert into externalUrls (url, type, project)
            values ('${project.trelloUrl}', 'Trello', '${project.project_id}')`
        );
      }
      if (project.slackUrl !== "") {
        await post(
          `insert into externalUrls (url, type, project)
            values ('${project.slackUrl}', 'Slack', '${project.project_id}')`
        );
      }
      if (project.sharepointUrl !== "") {
        await post(
          `insert into externalUrls (url, type, project)
            values ('${project.sharepointUrl}', 'Sharepoint', '${project.project_id}')`
        );
      }
      if (project.bim360Url !== "") {
        await post(
          `insert into externalUrls (url, type, project)
            values ('${project.bim360Url}', 'BIM360', '${project.project_id}')`
        );
      }
      if (project.miroUrl !== "") {
        await post(
          `insert into externalUrls (url, type, project)
            values ('${project.miroUrl}', 'Miro', '${project.project_id}')`
        );
      }
    }
    console.log(response);*/
    /*const projects = await getAllProjects();
    console.log(projects);
    for (let i = 0; i < projects.length; i++) {
      const project = projects[i];
      const active =
        project.currentStatus === "On-Going" ||
        project.currentStatus === "On-Hold";
      await post(
        `update projects set
          active=${active ? "1" : "0"}
          where project_id=${project.id}`
      );
    }*/
    /*const projects = await getAllProjects(false);
    console.log(projects);

    for (let i = 0; i < projects.length; i++) {
      const project = projects[i];
      if (project.people.length > 0) {
        if (project.phases.length === 0) {
          let start = "";
          let end = "";
          project.people.forEach((p) => {
            if (p.esLabit) {
              if (start === "") {
                start = p.start;
                end = p.end;
              } else {
                if (p.start < start) {
                  start = p.start;
                }
                if (p.end > end) {
                  end = p.end;
                }
              }
            }
          });
          if (start !== "") {
            project.phases.push({
              id: -1,
              start,
              end,
              name: project.name,
            });

            // Create phase BDD
            const response = await post(
              `insert into phase (name, start, end, project)
                values('${project.phases[0].name}', '${project.phases[0].start}', '${project.phases[0].end}', ${project.id})`
            );
            project.phases[0].id = response[0];
          }
        }
        if (project.phases.length > 0) {
          for (let j = 0; j < project.people.length; j++) {
            const p = project.people[j];
            if (p.esLabit) {
              const phase = project.phases.find((ph) => {
                return p.start >= ph.start && p.start <= ph.end;
              });
              if (phase) {
                console.log(
                  project.id,
                  phase.id,
                  p.peopleId,
                  p.role,
                  p.start,
                  p.end
                );

                const response = await post(
                  `insert into projectTeam (people, phase, role)
                    values(${p.peopleId}, ${phase.id}, '${p.role}')`
                );
                const id = response[0];

                await post(
                  `insert into projectTeamPeriods (start, end, projectTeam)
                    values ('${p.start}', '${p.end}', ${id})`
                );
              } else {
                console.log(
                  project.id,
                  "PERSONA SIN FASE!",
                  p.peopleId,
                  p.role,
                  p.start,
                  p.end
                );

                const response = await post(
                  `insert into projectTeam (people, phase, role)
                    values(${p.peopleId}, ${project.phases[0].id}, '${p.role}')`
                );
                const id = response[0];

                await post(
                  `insert into projectTeamPeriods (start, end, projectTeam)
                    values ('${project.phases[0].start}', '${project.phases[0].end}', ${id})`
                );
              }
            }
          }
        }
      }
    }*/
  });
</script>
